import { Component } from '@angular/core';

@Component({
  selector: 'app-card-getm',
  template: `
  <ion-card>
    <ion-card-content>
      <ng-content></ng-content>
    </ion-card-content>
  </ion-card>`,
  styleUrls: ['./card-getm.component.scss']
})
export class CardGetmComponent { }
